import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import ReactHtmlParser from 'react-html-parser';
import { useIntl } from 'react-intl';
import { localizePathname } from '@whitelabel/helpers/i18n';
import { captureExceptionWithFullyStory } from '@whitelabel/helpers/utils';
import { StyledLTRblock } from '../styled';

function formatAttributes(attribs: object) {
  let result = '';
  if (attribs) {
    result = Object.entries(attribs)
      .map(([name, value]) => `${name}="${value}"`)
      .join(' ');
  }
  return result;
}

function formatChildren(children: any) {
  let result = '';
  children.forEach((element: any) => {
    if (element.type === 'text') {
      result += element.data;
    } else if (element.type === 'tag') {
      result += `<${element.name} ${formatAttributes(element.attribs)}>${formatChildren(element.children)}</${
        element.name
      }>`;
    }
  });
  return result;
}

export const transformLink = (intl: any) => (node: any) => {
  if (node.type === 'tag' && node.name === 'a') {
    const { pathname } = useLocation();
    const { locale } = useIntl();
    const isNonEnPDS = locale !== 'en' && locale !== 'en-us' && pathname.includes('/pds/');
    if (!node.attribs.href) {
      if (isNonEnPDS) {
        return;
      }
      const error = new Error('HTML a tag is missing a valid href attribute');
      captureExceptionWithFullyStory(error);
      return;
    }

    if (node.attribs.href.startsWith('/')) {
      const path = localizePathname(node.attribs.href, intl.locale);

      return (
        <Link key={path} to={path}>
          {ReactHtmlParser(formatChildren(node.children))}
        </Link>
      );
    }

    if (node.attribs.href.startsWith('tel:')) {
      return (
        <a href={node.attribs.href}>
          <StyledLTRblock>{node.children[0].data}</StyledLTRblock>
        </a>
      );
    }
  }
  return undefined;
};
